
const convertDateFormat = (date = '') => {

  const dateObj = date === '' ? new Date() : new Date(date);

  // Use Intl.DateTimeFormat to format the date in Indonesian "2024-05-01";
  const options = { day: '2-digit', month: 'short', year: 'numeric' };

  // return must be '01 Mei 2024'
  return new Intl.DateTimeFormat('id-ID', options).format(dateObj);

}

const formatDateISO = (date = new Date()) => {
    // Convert the date to ISO string
    const isoString = date.toISOString();
    // Split at the "T" character to get the date part
    return isoString.split("T")[0];
};


export { convertDateFormat, formatDateISO };

